/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SingleBadge = {
    type: SingleBadge.type;
    badgeId: number;
};
export namespace SingleBadge {
    export enum type {
        BADGE = 'badge',
    }
}

